import { render, staticRenderFns } from "./ElByla.vue?vue&type=template&id=cf8d2224&scoped=true&"
import script from "./ElByla.vue?vue&type=script&lang=js&"
export * from "./ElByla.vue?vue&type=script&lang=js&"
import style0 from "./ElByla.vue?vue&type=style&index=0&id=cf8d2224&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8d2224",
  null
  
)

export default component.exports